import { render, staticRenderFns } from "./RegulatoryDeadlines.vue?vue&type=template&id=d58d1934"
import script from "./RegulatoryDeadlines.vue?vue&type=script&lang=js"
export * from "./RegulatoryDeadlines.vue?vue&type=script&lang=js"
import style0 from "./RegulatoryDeadlines.vue?vue&type=style&index=0&id=d58d1934&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d58d1934')) {
      api.createRecord('d58d1934', component.options)
    } else {
      api.reload('d58d1934', component.options)
    }
    module.hot.accept("./RegulatoryDeadlines.vue?vue&type=template&id=d58d1934", function () {
      api.rerender('d58d1934', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/RegulatoryDeadlines.vue"
export default component.exports